export default defineI18nConfig(() => ({
  legacy: false,
  flatJson: true,

  postTranslation: translated => {
    const config = useRuntimeConfig()

    if (import.meta.dev && config.public.debugTranslations) {
      return `#${translated}`
    }

    return translated
  }
}))
